import { apiAxios } from '@/lib/apiAxios';
export const fetchActivity = async (limit = 15) => apiAxios
    .get('/internal/dashboard/activity', { params: { limit } })
    .then((response) => response.data.data);
export const fetchTrends = async (days = 30) => apiAxios
    .get('/internal/dashboard/trends', { params: { days } })
    .then((response) => response.data.data);
export const fetchLeaderboards = async () => apiAxios
    .get('/internal/dashboard/leaderboards')
    .then((response) => response.data);
export const fetchWorkspaceOverview = async () => apiAxios
    .get('/internal/dashboard/workspaces')
    .then((response) => response.data);
